import { api } from '@/api/client'
import type { Cart } from '@/api/orders'
import type { ProductUnit } from '@/api/suppliers'

/** Ένας προμηθευτής που μπορεί να φέρει το συγκεκριμένο είδος. */
export interface SupplierOption {
  supplierId: string
  supplierName: string
  businessItemId: string
  supplierProductId: string | null
  price: string | null
  isAvailableToday: boolean
  unavailableUntil: string | null
  /** Εκείνος που χρησιμοποιήθηκε τελευταία φορά για αυτό το είδος. */
  isPreferred: boolean
}

export interface ShoppingListItem {
  key: string
  name: string
  unit: ProductUnit
  /** Η κατηγορία της επιχείρησης («Καφέδες»). */
  category: string | null
  categoryId: string | null
  /** Μόνιμη παρατήρηση του είδους. */
  note: string | null
  defaultQuantity: string
  isFavorite: boolean
  baseProductId: string | null
  /** Πόσες φορές παραγγέλθηκε πρόσφατα. Τροφοδοτεί τα «συνηθισμένα». */
  orderCount: number
  options: SupplierOption[]
}

export interface ShoppingList {
  items: ShoppingListItem[]
  /** Με τη σειρά που τις τακτοποίησε η επιχείρηση. */
  categories: { id: string; name: string }[]
  supplierCount: number
  multiSupplierCount: number
}

export interface ShoppingListLine {
  supplierId: string
  businessItemId: string
  quantity: string
  note?: string
}

export const shoppingListApi = {
  get: (params?: { search?: string; favoritesOnly?: boolean }) => {
    const query = new URLSearchParams()
    if (params?.search) query.set('search', params.search)
    if (params?.favoritesOnly) query.set('favoritesOnly', 'true')
    const suffix = query.toString()
    return api.get<ShoppingList>(`/shopping-list${suffix ? `?${suffix}` : ''}`)
  },
  categories: () => api.get<string[]>('/shopping-list/categories'),
  submit: (lines: ShoppingListLine[]) => api.post<Cart>('/shopping-list/submit', { lines }),
}
